import React from "react";
import styled, { css } from "styled-components";
import Chip from "@mui/material/Chip";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const FrostedCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 340px;
  border-radius: 1.5rem;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    rgba(30, 30, 40, 0.85),
    rgba(20, 20, 30, 0.85)
  );
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  border: 1.5px solid rgba(144, 202, 249, 0.18);
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
  transition: box-shadow 0.1s cubic-bezier(0.4, 0.2, 0.2, 1),
    border 0.1s cubic-bezier(0.4, 0.2, 0.2, 1);
  ${(props) =>
    props.$clickable
      ? css`
          cursor: pointer;
          &:hover {
            border: 1.5px solid #90caf9;
            box-shadow: 0 0 0 4px rgba(144, 202, 249, 0.25),
              0 8px 32px rgba(0, 0, 0, 0.18);
          }
        `
      : css`
          cursor: default;
          &:hover {
            border: 1.5px solid rgba(144, 202, 249, 0.18);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
            filter: none;
          }
          opacity: 0.98;
        `}
`;

const CardImage = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  background: ${({ src }) =>
    src && !src.endsWith(".gif")
      ? `url(${src}) center/cover no-repeat`
      : `linear-gradient(120deg, #444 40%, #888 100%)`};
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.13);
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.08) 60%,
      rgba(30, 30, 40, 0.38) 100%
    );
    pointer-events: none;
  }
  overflow: hidden;
`;

const CardContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 1.5rem 1.3rem 1.2rem 1.3rem;
  color: #fff;
`;

const ChipsRow = styled.div`
  margin-bottom: 0.7rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

const CardTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.4rem;
  letter-spacing: -0.01em;
  line-height: 1.2;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
`;

const CardSubtitle = styled.div`
  font-size: 1.02rem;
  color: #e3f2fd;
  margin-bottom: 0.7rem;
  font-weight: 400;
  line-height: 1.4;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;

const CardMeta = styled.div`
  font-size: 0.92rem;
  color: #b3b3b3;
  margin-top: auto;
  font-weight: 400;
  letter-spacing: 0.01em;
`;

const CardCredit = styled.div`
  position: absolute;
  bottom: 0.5rem;
  right: 0.7rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  padding: 0.18rem 0.6rem;
  border-radius: 0.3rem;
  font-size: 0.78rem;
  z-index: 2;
  text-align: right;
`;

// VideoLabel removed

const FrostedCard = ({
  image,
  isGif,
  title,
  subtitle,
  chips,
  meta,
  credit,
  onClick,
  children,
  clickable = true,
  ...rest
}) => {
  return (
    <FrostedCardContainer
      onClick={clickable ? onClick : undefined}
      $clickable={clickable}
      aria-disabled={!clickable}
      tabIndex={clickable ? 0 : -1}
      {...rest}
    >
      {/* VideoLabel removed */}
      {image && (
        <CardImage src={image}>
          {isGif && (
            <img
              src={image}
              alt="thumbnail"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 0,
              }}
            />
          )}
          {credit && (
            <CardCredit>
              Img Credit:
              <br />
              {credit}
            </CardCredit>
          )}
        </CardImage>
      )}
      <CardContentSection style={{ position: "relative" }}>
        {chips && chips.length > 0 && (
          <ChipsRow>
            {chips.map((chip, idx) => (
              <Chip
                key={idx}
                label={chip}
                sx={{
                  border: "1px solid #fff",
                  color: "#fff",
                  fontSize: "0.85rem",
                  height: "24px",
                  background: "rgba(255,255,255,0.08)",
                  fontWeight: 500,
                }}
                variant="outlined"
              />
            ))}
          </ChipsRow>
        )}
        {title && <CardTitle>{title}</CardTitle>}
        {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
        {meta && <CardMeta>{meta}</CardMeta>}
        {children}
      </CardContentSection>
    </FrostedCardContainer>
  );
};

export default FrostedCard;
